import { render, staticRenderFns } from "./DailyLiveStockTable.vue?vue&type=template&id=6804db56&scoped=true&"
import script from "./DailyLiveStockTable.vue?vue&type=script&lang=ts&"
export * from "./DailyLiveStockTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6804db56",
  null
  
)

export default component.exports